import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for app shell caching —
// makes the app load instantly even after hours of inactivity.
//
// Production only: the service worker's /static/ handling is cache-first
// forever, which is correct for production's content-hashed filenames but
// actively harmful under `npm start` — CRA's dev server serves the bundle
// at a fixed, non-hashed path, so once cached it would keep serving that
// exact stale copy through every subsequent edit, hot-reload, and even
// hard refresh (a normal reload still goes through the active service
// worker) until manually unregistered.
//
// updateViaCache: 'none' is critical — without it, browsers are allowed to
// serve the service-worker.js SCRIPT FILE ITSELF from HTTP cache for up to
// 24 hours before checking for changes, meaning a new deploy could take up
// to a day to even be detected. This forces every load to check the network
// for a fresh copy of the service worker script.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/', updateViaCache: 'none' })
      .then(reg => {
        // Actively check for a newer service worker on every load, and
        // again periodically while the app stays open in the background.
        reg.update();
        setInterval(() => reg.update(), 60 * 60 * 1000); // re-check hourly

        // If a new service worker takes over while the app is open,
        // reload once to pick up the new version immediately rather than
        // waiting for the next manual app restart.
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      })
      .catch(err => {
        console.warn('Service worker registration failed:', err);
      });
  });
}
